import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
// #region Custom Classes
var BaseOptionBoxDialogOptions = /** @class */ (function () {
    function BaseOptionBoxDialogOptions() {
    }
    return BaseOptionBoxDialogOptions;
}());
export { BaseOptionBoxDialogOptions };
var BaseOptionBoxOption = /** @class */ (function () {
    function BaseOptionBoxOption(displayText, color, response, closes) {
        this.DisplayText = displayText;
        this.Color = color || 'primary';
        this.Response = response;
        this.ClosesDialog = (closes != null ? closes : true);
    }
    return BaseOptionBoxOption;
}());
export { BaseOptionBoxOption };
// #endregion
var OptionBoxDialogComponent = /** @class */ (function () {
    function OptionBoxDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.title = data.TitleText || 'Confirmation Requested...';
        this.message = data.MessageText || '';
        this.options = data.Options || [
            new BaseOptionBoxOption('OK', 'primary', true), new BaseOptionBoxOption('Cancel', 'warn', null)
        ];
    }
    OptionBoxDialogComponent.prototype.OptionHandler = function (choice) {
        this.dialogRef.close(choice);
    };
    OptionBoxDialogComponent.prototype.ngOnInit = function () {
    };
    return OptionBoxDialogComponent;
}());
export { OptionBoxDialogComponent };
